module.exports = __webpack_public_path__ + "img/new_yourorder_en.6c3d8d98.png";